import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'HVw6qER8dQdXrRsr64IJm35emP7fX4pDz9T8faBQ',
  authDomain: 'privatewealthseminars-2020.firebaseapp.com',
  databaseURL: 'https://privatewealthseminars-2020.firebaseio.com',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.database();

export default db;



// WEBPACK FOOTER //
// ./src/db.js